import React, {useEffect} from "react";
import {Dialog, DialogTitle, DialogContent, IconButton, Typography,  ListItem, ListItemText, Skeleton} from "@mui/material";
import CloseIcon from "../../../assets/icons/close.png";
import useActivityLogs from "../../../hooks/useActivityLogs";
import moment from "moment";

const ActivityLogDetailViewDialog = (props) => {

    const {activityId, openActivityLogDetailView, setOpenActivityLogDetailView} = props;

    const {activityLogsDetails, isFetchingLogDetails, viewActivityLogs} = useActivityLogs();

    const handleCloseDialog = () => {
        setOpenActivityLogDetailView(false);
    }

    useEffect(() => {
        viewActivityLogs(activityId);
    }, [activityId])


    return (
        <Dialog open={openActivityLogDetailView} onClose={handleCloseDialog} maxWidth="sm" fullWidth PaperProps={{style: {borderRadius: "8px", padding: " 20px 24px"}, elevation: 24}}>
            <DialogTitle sx={{display: "flex"}}>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={{position: 'absolute', right: 36, top: 24}}
                >
                    <img alt="close-icon" src={CloseIcon} style={{height: 22}} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{padding: "20px 8px"}}>
                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                User ID: 
                            </Typography>
                        } 
                        secondary={(isFetchingLogDetails) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, fontWeight: "bold", ml: 1}}>
                                {activityLogsDetails?.user_id}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                User Email: 
                             </Typography>
                        } 
                        secondary={(isFetchingLogDetails) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {activityLogsDetails?.user_email}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                User Type:  
                             </Typography>
                        } 
                        secondary={(isFetchingLogDetails) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "320px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {activityLogsDetails?.user_type}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                               Module:  
                            </Typography>
                        } 
                        secondary={(isFetchingLogDetails) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "350px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {activityLogsDetails?.module}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                               Action:  
                            </Typography>
                        } 
                        secondary={(isFetchingLogDetails) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "350px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {activityLogsDetails?.action}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                               Activity:  
                            </Typography>
                        } 
                        secondary={(isFetchingLogDetails) ?
                            <div style={{display: "block"}}>
                            <Skeleton variant="text" sx={{fontSize: 14, width: "345px", backgroundColor: "#d8d8fdbd", ml: 1, mb: "6px"}} /> 
                            <Skeleton variant="text" sx={{fontSize: 14, width: "360px", backgroundColor: "#d8d8fdbd", ml: 1, mb: "6px"}} />
                            <Skeleton variant="text" sx={{fontSize: 14, width: "360px", backgroundColor: "#d8d8fdbd", ml: 1, mb: "6px"}} />
                            <Skeleton variant="text" sx={{fontSize: 14, width: "360px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                            </div>
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {activityLogsDetails?.activity}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                               Timestamp:  
                            </Typography>
                        } 
                        secondary={(isFetchingLogDetails) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "345px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {moment(activityLogsDetails?.timestamp).format("MMMM DD, YYYY HH:mmA")}
                            </Typography>
                        }
                    />
                </ListItem>
            </DialogContent>
        </Dialog>
    )
}

export default ActivityLogDetailViewDialog

